<template>
    <div class="bg-white dark:bg-gray-800">
        <Hero :hero="params"></Hero>
        <Breadcrumbs :breadcrumbs="crumbs" :page="pagename"></Breadcrumbs>
        <content :data="params"></content>
    </div>
</template>

<script>
import Breadcrumbs from '../layouts/breadcrumb.vue'
import Hero from '../layouts/Hero.vue'
import Content from '../components/Other/ContentDetailBunga.vue'
export default {
    name: 'ClientDbunga',
    props : ['name'],
    data() {
        return {
            params:{},
            pagename: null,
            crumbs: []
        };
    },

    created() {
        this.getparams();
    },

    methods: {
        getparams(){
             this.axios.get('api/getrate/'+this.name).then((response) => {
                
                let slink = false;
                let ilink = false;

                if(response.data.showlink == 'true'){
                    slink = true
                }

                if(response.data.internallink == 'true'){
                    ilink = true
                }
                this.params = {
                    id: response.data.id,
                    title: response.data.title,
                    img: response.data.imagepath,
                    detail: response.data.detail,
                    permalink:response.data.permalink,
                    link: response.data.link,
                }
                this.pagename = response.data.title

                this.crumbs = [
                    {key:"Suku Bunga", link:"/suku-bunga"},
                    {key:response.data.title, link: "/suku-bunga/"+response.data.permalink}
                ]

                document.title = response.data.title + ' | Bank Padma'
                document.querySelector('head meta[name="description"]').setAttribute('content', response.data.description);
                document.querySelector('head meta[name="og:description"]').setAttribute('content', "");
                document.querySelector('head meta[name="og:title"]').setAttribute('content', response.data.title + ' | Bank Padma');
                document.querySelector('head meta[name="keywords"]').setAttribute('content', "");
                document.querySelector('head meta[name="og:url"]').setAttribute('content', window.location.href);
                document.querySelector('head meta[name="og:image"]').setAttribute('content', response.data.imagepath);
                
               
            }).catch(error => {
                
            console.log(error)

            }).finally(() => {
                
            })     
        }
    },
    components:{
        Breadcrumbs,
        Hero ,
        Content   
    }
};
</script>

<style lang="scss" scoped>

</style>